module.exports = __webpack_public_path__ + "img/1-8587.3ac50c3e.png";